export default {
  'text/plain': 'file-text',
  'application/pdf': 'file-pdf',
};
